<template>
  <div style="background-color: #f0f0f0">
    <FormKit
        v-model="value"
        type="radio"
        label="Preferred transportation"
        :options="['E-Bike', 'E-Scooter', 'Electric car', 'Walking', 'Space tube']"
        help="How do you like to get around?"
    />
  </div>

</template>

<script setup>



</script>

<style scoped>

</style>
